'use client';
import { forwardRef } from 'react';
import s from './CustomCursorElement.module.scss';
import Play from '@/app/components/ui/icons/Play';
import ArrowUpRight from '@/app/components/ui/icons/ArrowUpRight';
import { useModal } from '@/context/ModalContext';
import SmallArrowLeft from '@/app/components/ui/icons/SmallArrowLeft';
import SmallArrowRight from '@/app/components/ui/icons/SmallArrowRight';

const CustomCursorElement = forwardRef(
  (
    {
      cursorOptions = {},
      position,
      isActive,
      isStatic = false,
      onClick,
      openPopupOnClick,
      customText = '',
    },
    ref
  ) => {
    const iconMap = {
      play: <Play color="#000000" />,
      arrow: <ArrowUpRight />,
    };

    let {
      size = 'default',
      variant = 'primary',
      text = '',
      icon = 'arrow',
      isSlider = false,
    } = cursorOptions || {};

    const { openModal } = useModal();

    const handleClick = () => {
      onClick && onClick();

      if (openPopupOnClick) {
        openModal();
      }
    };

    if (customText) {
      text = customText;
    }

    return (
      <div
        ref={ref}
        className={`${s.customCursor} ${s[size]} ${s[variant]} ${isStatic ? s.static : ''}`}
        style={{
          transform: isStatic
            ? 'none'
            : `translate(${position.x}px, ${position.y}px) scale(${isActive ? 1 : 0})`,
          position: isStatic ? 'relative' : 'absolute',
          cursor: isStatic ? 'pointer' : 'none',
        }}
        onClick={handleClick}
      >
        {isSlider ? (
          <div className={s.arrows}>
            <SmallArrowLeft />
            <SmallArrowRight />
          </div>
        ) : (
          icon && <div className={s.icon}>{iconMap[icon] || null}</div>
        )}

        {text && <span className={`${s.text} buttonText`}>{text}</span>}
      </div>
    );
  }
);

export default CustomCursorElement;
